import Vimeo from '@u-wave/react-vimeo'
import React, { useEffect, useState } from 'react'
import { FadeLoader } from 'react-spinners'
import Button from '../../../../components/button'
import { Link, useNavigate } from 'react-router-dom'
import TickMark from '../../../../components/tickmark'
import { saveStepsProgress } from '../../../../services/medium'
import { useTranslation, Trans } from 'react-i18next'

export default function StepFour({ NextStep, innerWidthHandler }) {
    const { t } = useTranslation("mediumBooking");
    const navigate = useNavigate();

    const [showLoader, setShowLoader] = useState(true);
    const [verificationStatus, setVerificationStatus] = useState(0);

    const openAppointMent = () => {
        window.open("/integration", "_blank", "noreferrer")
    }
    useEffect(() => {
        setTimeout(() => {
            setVerificationStatus(1);
            setShowLoader(false);
        }, 7000)
    })
    const savestep = () => {
        let body = {
            step_number: 4
        }
        saveStepsProgress(body).then((data) => {
            if (data.data.status) {
                localStorage.setItem('step', 4)
                NextStep()
            }
        }).catch(() => {

        })
    }
    return (
        <div className="onboarding-step-content">
            <div className='onboarding-step-header text-left'>

                <span className="onboarding-step-badge">{t("steps.stepNumber", { number: 4 })}</span>
                <div>
                    <h3 className='font-size-40 '>{t("step4.title")}</h3>
                    <ol className='font-size-18 line-height-24px'>
                        <li>{t("steps.watchVideo")}</li>
                        <li>
                            <Trans
                                i18nKey="step4.review"
                                ns="mediumBooking"
                                components={{ anchor: <Link className='practice-my-app' to="/appointments?from=onboarding" target='_blank' /> }}
                            />
                        </li>
                        <li>{t("step4.clickNext")}</li>
                    </ol>
                </div>
                {/* <p className='font-size-18 line-height-24px'>This video will give a general overview for your My Appointments page.</p> */}


            </div>
            <div className="onboarding-media-card">
                <div className="onboarding-media-header">
                    <h5>{t("steps.watchWalkthrough")}</h5>
                </div>
                <div className="onboarding-media-body">
                    <div className="onboarding-video-wrap ratio ratio-16x9">
                        <Vimeo
                            muted={true}
                            autoplay={false}
                            // className="popover-video"
                            width={innerWidthHandler()}
                            height={330}
                            video={"https://vimeo.com/922676519/c68142040f"}
                        />
                    </div>
                </div>
            </div>

            <div className='onboarding-actions'>

                <Button
                    className={"action-button margin-unset"}
                    status={0}
                    onClick={() => savestep()}
                    title={t("steps.next")} />

                {/* <Button
                    className={"action-button margin-unset ml-5"}
                    status={0}
                    onClick={openAppointMent}
                    title="Link your Zoom" />
 */}

            </div>

        </div>
    )
}
